import type { SupportStoreType } from '../../models/partner.ts';
import { Badge, Text, Group } from '@mantine/core';

import { serviceMap } from '../../const/service_type_mapping.ts';

export function SupportStoreTypeBadges({
  supportStoreTypes,
}: {
  supportStoreTypes: SupportStoreType[];
}) {
  function getSupportStoreTypeBadgesStyle(supportStoreType: SupportStoreType) {
    switch (supportStoreType) {
      case 'Parkinglot':
        return { content: '停車場', backgroundColor: serviceMap.PARKING.color };
      case 'GasStation':
        return { content: '加油站', backgroundColor: serviceMap.FUELING.color };
      case 'ChainStore':
        return { content: '連鎖店', backgroundColor: '#FFF3BF' };
      default:
        throw new Error('Invalid contract type');
    }
  }

  return (
    <Group gap="xs">
      {supportStoreTypes.map((supportStoreType) => {
        const { backgroundColor, content } =
          getSupportStoreTypeBadgesStyle(supportStoreType);
        return (
          <Badge color={backgroundColor}>
            <Text size="xs" c="black">
              {content}
            </Text>
          </Badge>
        );
      })}
    </Group>
  );
}
